import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Subnav from 'components/Subnav';
import routes, { PROFILE_ROUTE_LABEL_ID } from '../../routes';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import { hasNotSeenDiscoveryFeature } from 'utils';
import { FIRST_RELEASE_DISCOVERING_FEATURE } from 'data/discoveringFeature';

import './ProfileSubnav.styles.scss';

type ProfileSubnavProps = {
  className?: string;
  isBossMode?: boolean;
};

const ProfileSubnav: React.FC<ProfileSubnavProps> = (props) => {
  const { className, isBossMode } = props;

  const { t } = useTranslation();
  const {
    currentUser: { seenEnquiryContextFeature },
  } = useContext(CurrentUserContext);

  const links = useMemo(
    () =>
      routes
        .filter(
          (r) =>
            r.labelId &&
            (!isBossMode || r.labelId !== PROFILE_ROUTE_LABEL_ID.SETTINGS),
        )
        .map(({ path, labelId, ...rest }) => {
          const isNewFeature =
            labelId === PROFILE_ROUTE_LABEL_ID.PREFERENCES &&
            hasNotSeenDiscoveryFeature(
              seenEnquiryContextFeature,
              FIRST_RELEASE_DISCOVERING_FEATURE,
            );

          return {
            label: t(labelId),
            to: path,
            isNew: isNewFeature,
            className: classNames({
              'new-feature': isNewFeature,
            }),
            ...rest,
          };
        }),
    [isBossMode, seenEnquiryContextFeature, t],
  );

  const classes = classNames('profile-subnav', className);

  return (
    <div className={classes}>
      <Subnav links={links} />
    </div>
  );
};

export default ProfileSubnav;
